'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('calendar-edit', {
      url: '/calendar/:type/edit/:id',
      template: '<calendar-edit></calendar-edit>',
      params: {cloneId: null},
      authenticate: true
    })
    .state('calendar-group-edit', {
    url: '/calendar/group/:group/edit/:id',
    template: '<calendar-edit is-group="true"></calendar-edit>',
    params: {cloneId: null},
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/calendar/edit/calendar-edit.routes.js